@if (label) {
	<ic-label [help]="help" [required]="required"> {{ label }} </ic-label>
}

<ul cdkDropList cdkDropListOrientation="horizontal" class="order-list" (cdkDropListDropped)="drop($event)">
	@for (item of value; track item; let index = $index) {
		<li
			cdkDrag
			cdkDragBoundary=".order-list"
			cdkDragLockAxis="x"
			class="is-draggable"
			[cdkDragDisabled]="isDisabled"
			(click)="edit(index)"
		>
			@if (formTemplate) {
				<i class="fa fa-times-circle delete" (focusClick)="remove(index)"> </i>
			}
			@if (itemTemplate) {
				<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item, index: index }" />
			} @else {
				{{ item }}
			}
		</li>
	}

	@if (value.length === 0 && emptyTemplate) {
		<li><ng-template [ngTemplateOutlet]="emptyTemplate" /></li>
	}

	@if (!isFormVisible && addTemplate && formTemplate) {
		<li (focusClick)="showForm()">
			<ng-template [ngTemplateOutlet]="addTemplate" />
		</li>
	}
</ul>

@if (formTemplate && isFormVisible) {
	<div class="order-add-form">
		<ng-template [ngTemplateOutlet]="formTemplate" />
		<div class="ic-buttons">
			<span [icValidateForms]="[form]" (confirm)="save()"> <ng-content select=".save" /> </span>
			<span (focusClick)="cancel()"> <ng-content select=".cancel" /> </span>
		</div>
	</div>
}
